import { SavedReportPageBody } from "pages/reports/saved-report-page"
import { useTimesheetsTopNavigationLinks } from "./hooks/use-timesheets-top-navigation-links"

export function SavedTimesheetPage() {
  useTimesheetsTopNavigationLinks()

  return <SavedReportPageBody />
}